import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { setOptions, overrideComponent, setMetadata, StudentPersonalInfoViewModel, EmailLoopVerificationRequest, setViewModel, Locale, assertValidLocale, postVerificationSizeUpdates } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

import { StepStudentPersonalInfoComponent } from './components/steps/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';
import { StepDocUploadComponent } from './components/steps/StepDocUploadComponent'
import { StepSSOComponent } from './components/steps/StepSSOComponent'
import { StepErrorComponent } from './components/steps/StepErrorComponent'

import { getQueryParamsByName } from './lib/utils/browser';
import { AllowedCountries } from './lib/types/types';

overrideComponent('StepSuccessComponent',StepSuccessComponent)
// @ts-expect-error
overrideComponent('StepDocUploadComponent',StepDocUploadComponent)
overrideComponent('StepSSOComponent',StepSSOComponent)

const country = getQueryParamsByName('country') || '';
const promotionUsedCount = getQueryParamsByName('promotionUsedCount') || '';
const storeType = getQueryParamsByName('storeType') || '';
const siteRoot = getQueryParamsByName('siteRoot') || '';
const channel = getQueryParamsByName('channel') || '';
const currency = getQueryParamsByName('currency') || '';
let locale = getQueryParamsByName('language') || '';
const storeID = getQueryParamsByName('storeID') || '';
const cartID = getQueryParamsByName('cartID') || '';
const utm_cid = getQueryParamsByName('utm_cid') || '';
const redirectUrl = getQueryParamsByName('redirectUrl') || 'https://www.lenovo.com/us/en/';

try {
  assertValidLocale(locale as Locale);
} catch (error) {
  locale = 'en-US';
}

setMetadata({ promotionUsedCount, country, storeType, siteRoot, channel, currency, language: locale, storeID, cartID, utm_cid, redirectUrl });

if ((country !== 'JP' && country !== 'HK' && country !== 'IN' && country !== 'MY' && country !== 'SG' && country !== 'KR' && country !== 'TW' && country !== 'TH' && country !== 'PH' && country !== '')) {
  //@ts-expect-error
  overrideComponent('StepStudentPersonalInfoComponent',StepErrorComponent)
} else {
    //@ts-expect-error
 overrideComponent('StepStudentPersonalInfoComponent',StepStudentPersonalInfoComponent)
}

const defaultViewModel: StudentPersonalInfoViewModel & EmailLoopVerificationRequest = {
  countryChoice: { value: getQueryParamsByName('country') as AllowedCountries, label: '' },
  email: '',
  firstName: '',
  lastName: '',
  birthDate: '',
  localeChoice: {
    value: locale as Locale,
    label: undefined,
  },
  organization: {
    id: 0,
    name: ''
  },
  metadata: {
  },
  emailToken: ''
};
setViewModel(defaultViewModel);

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);



